import axios from 'axios'

// Get all tickets from show date
const getAll = async (showDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/ticket/${showDate}`)
  return data
}

// Get all tickets from show date
const getAllComplete = async (showDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/ticket/${showDate}/complete`)
  return data
}

// Get ticket from show date and id
const get = async (showDate, id) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/ticket/${showDate}/${id}`)
  return data
}

// Create tickets
const create = async (
  showDate,
  showPrice,
  section,
  seats,
  status,
  paymentMethod,
  customers
) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/ticket`, {
    showDate,
    showPrice,
    section,
    seats,
    status,
    paymentMethod,
    customers
  })
  return data
}

// Update tickets
const update = async (
  ids,
  withSection,
  showPrice,
  section,
  seats,
  status,
  paymentMethod,
  customers
) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/ticket`, {
    ids,
    withSection,
    showPrice,
    section,
    seats,
    status,
    paymentMethod,
    customers
  })
  return data
}

// Cancel ticket
const cancel = async (id, reason) => {
  const { data } = await axios.delete(`${process.env.VUE_APP_API}/ticket/${id}`, { data: { reason } })
  return data
}

// Validate ticket
const validate = async (showDate, key) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/ticket/${showDate}/${key}/validate`)
  return data
}

// Get tickets grouped by type
const getGrouped = async (showDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/ticket/${showDate}/grouped`)
  return data
}

// Get tickets grouped by type (producer)
const getGroupedProducer = async (showDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/ticket/${showDate}/grouped/producer`)
  return data
}

// Remove booked tickets
const removeBooked = async (ids) => {
  const { data } = await axios.delete(`${process.env.VUE_APP_API}/ticket/book`, { data: { ids } })
  return data
}

// Get tickets for report
const getForReport = async (iniDate, endDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/ticket/report/${iniDate}/${endDate}`)
  return data
}

// Print ticket
const print = async (business, showDate, ids) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/ticket/print`, { params: {
    business,
    showDate,
    ids
  } })
  return data
}

// Get all customers with ticket
const getAllCustomers = async (showDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/ticket/${showDate}/customers`)
  return data
}

export {
  getAll,
  get,
  create,
  update,
  cancel,
  validate,
  getGrouped,
  getGroupedProducer,
  getAllComplete,
  removeBooked,
  getForReport,
  print,
  getAllCustomers
}
